import moment from 'moment'

export function generateUrl (url, key, params) {
  if (url.indexOf('?') > -1) {
    url = `${url}&${key}=${params}`
  } else {
    url = `${url}?${key}=${params}`
  }
  return url
}

export function formatNumber (number, places, thousand, decimal) {
  number = number || 0
  places = !isNaN(places = Math.abs(places)) ? places : 2
  thousand = thousand || ','
  decimal = decimal || '.'
  let negative = number < 0 ? '-' : ''
  let i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + ''
  let j = (j = i.length) > 3 ? j % 3 : 0
  return negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '')
}

export function removeComma (number) {
  return number.replace(/,/g, '')
}

export function removeDot (number) {
  return number.replace(/\./g, '')
}

export function removeString (str) {
  return str.replace(/\D/g, '')
}

export function formatDate (value, strFormat = 'YYYY-MM-DD') {
  if (value) {
    return moment(value).format(strFormat)
  }
  return ''
}

export function copyText (text) {
  // Create the textarea input to hold our text.
  let element = document.document.createElement('textarea')
  element.value = text
  // Add it to the document so that it can be focused.
  document.document.body.appendChild(element)
  // Focus on the element so that it can be copied.
  element.focus()
  element.setSelectionRange(0, element.value.length)
  // Execute the copy command.
  document.document.queryCommandSupported('copy')
  document.document.execCommand('copy')
  // Remove the element to keep the document clear.
  document.document.body.removeChild(element)
}



// WEBPACK FOOTER //
// ./src/helpers/index.js